import React from "react";
import { Button as PrimereactBtn } from "primereact/button";
import { Card } from "primereact/card";
import TotalRecords from "../../../../components/core/total-records";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { useSelector } from "react-redux";

const NewPartnerTable = ({
  data,
  searchResultSentence = "",
  handleAddPartnerAccount,
  handleEditClick,
}) => {
  const formatValue = (value) => {
    const number = parseFloat(value);
    if (isNaN(number)) return value;

    const formatted = number.toLocaleString("en-PH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `₱ ${formatted}`;
  };
  const accessPermissions = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column
          header="Partner Category"
          sortable={true}
          field="partnerCategory.partnerCategory"
          colSpan={1}
          rowSpan={2}
          alignHeader={"center"}
          className="border-r-2 items-center justify-center text-center"
          headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
        />
        <Column
          header="Partner"
          field="companyFullname"
          colSpan={1}
          alignHeader={"center"}
          className="border-r-2 items-center justify-center text-center"
          headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
          rowSpan={2}
        />
        <Column
          header="Partner Features"
          colSpan={3}
          rowSpan={1}
          alignHeader={"center"}
          className="border-r-2 border-b-2 items-center justify-center text-center"
          headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
        />
        <Column
          header="Monthly Fee"
          alignHeader={"center"}
          className="border-r-2 items-center justify-center text-center"
          headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
          // sortable={true}
          field="paymentSchedule.monthlyFee"
          colSpan={1}
          rowSpan={2}
        />
        <Column
          header="Partner Load Balance"
          // sortable={true}
          field="walletBalance"
          colSpan={1}
          rowSpan={2}
          alignHeader={"center"}
          className="border-r-2 items-center justify-center text-center"
          headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
        />
        <Column
          header=""
          colSpan={1}
          rowSpan={2}
          className="border-r-2 items-center justify-center text-center"
          headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
        />
      </Row>
      <Row>
        <Column
          header="Payment on Delivery"
          // sortable={true}
          field="featuresCod"
          alignHeader={"center"}
          className="border-r-2 items-center justify-center text-center"
          headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
        />
        <Column
          header="Shipout Service"
          // sortable={true}
          field="featuresShipout"
          alignHeader={"center"}
          className="border-r-2 items-center justify-center text-center"
          headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
        />
        <Column
          header="Accepts Returns"
          field="featuresReturns"
          alignHeader={"center"}
          className="border-r-2 items-center justify-center text-center"
          headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
        />
      </Row>
    </ColumnGroup>
  );

  return (
    <Card className="mt-3">
      <TotalRecords count={data.length} />

      <DataTable
        value={data}
        header={
          <div className="p-3 bg-primary-primaryYellow outline outline-primary-primaryYellow text-secondary-purpleGray text-center">
            {searchResultSentence}
          </div>
        }
        paginator
        paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
        currentPageReportTemplate="Rows per page"
        paginatorRight
        rowsPerPageOptions={[10, 20, 50]}
        rows={10}
        stripedRows
        showGridlines
        removableSort
        className="border-x-2 "
        headerColumnGroup={headerGroup}
      >
        <Column
          header="Partner Category"
          className="border-r-2 items-center justify-center text-center"
          body={(rowData) => (
            <Tag
              icon={
                rowData.partnerCategory.partnerCategory === "Seller"
                  ? "fa-solid fa-store"
                  : "fa-solid fa-truck-fast"
              }
              className={`${
                rowData.partnerCategory.partnerCategory === "Seller"
                  ? "border border-secondary-darkGray bg-white text-black"
                  : "border text-secondary-darkGray border-primary-primaryYellow bg-white"
              } text-sm space-x-1 w-[90px]`}
            >
              {rowData.partnerCategory?.partnerCategory}
            </Tag>
          )}
        />
        <Column
          header="Partner"
          field="partner"
          className="max-w-[250px] break-words border-r-2 "
        />
        <Column
          header="Shipout Service"
          field="featuresShipout"
          bodyClassName="text-center"
          className="max-w-[250px] break-words border-r-2 "
          body={(rowData) => {
            return rowData.featuresShipout === 1 ? (
              <i
                className="pi pi-check-circle"
                style={{ color: "#22c55e", fontSize: "14px" }}
              />
            ) : (
              <i
                className="pi pi-times-circle"
                style={{ color: "#ef4444", fontSize: "14px" }}
              />
            );

            // );
          }}
        />
        <Column
          header="Payment on Delivery Service"
          field="featuresCod"
          bodyClassName="text-center"
          className="max-w-[250px] break-words border-r-2 "
          body={(rowData) => {
            return rowData.featuresCod === 1 ? (
              <i
                className="pi pi-check-circle"
                style={{ color: "#22c55e", fontSize: "14px" }}
              />
            ) : (
              <i
                className="pi pi-times-circle"
                style={{ color: "#ef4444", fontSize: "14px" }}
              />
            );

            // );
          }}
        />
        <Column
          header="Accepts Returns"
          field="featuresReturns"
          bodyClassName="text-center"
          className="max-w-[250px] break-words border-r-2 "
          body={(rowData) => {
            return rowData.featuresReturns === 1 ? (
              <i
                className="pi pi-check-circle"
                style={{ color: "#22c55e", fontSize: "14px" }}
              />
            ) : (
              <i
                className="pi pi-times-circle"
                style={{ color: "#ef4444", fontSize: "14px" }}
              />
            );

            // );
          }}
        />

        {/* <Column
              header="Enabled Features"
              alignHeader={"center"}
              field="enabledFeatures"
              headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
              className="max-w-[250px] break-words border-r-2 "
            /> */}
        <Column
          header="Monthly Fee"
          alignHeader={"center"}
          field="monthlyFee"
          className="border-r-2"
          headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
          body={(rowData) => {
            return (
              <span>
                {rowData.monthlyFee !== 0
                  ? formatValue(rowData.monthlyFee)
                  : "-"}
              </span>
            );
          }}
        />
        <Column
          header="Partner Load Balance"
          field="walletBalance"
          alignHeader={"center"}
          className="border-r-2"
          headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
          body={(rowData) => {
            return (
              <span>
                {rowData.walletBalance !== 0
                  ? formatValue(rowData.walletBalance)
                  : "-"}
              </span>
            );
          }}
        />

        <Column
          header=""
          alignHeader={"center"}
          className=""
          headerClassName="bg-primary-primaryYellow border-r-2 text-secondary-purpleGray"
          body={(rowData) => {
            const adminAccess = rowData.adminAccess;

            return (
              <div className="flex items-center justify-center gap-2 w-full">
                {adminAccess ? (
                  <>
                    <PrimereactBtn
                      // label="Edit"
                      icon={`${
                        accessPermissions.partners === 1 ||
                        accessPermissions.partners === "1"
                          ? "pi pi-eye"
                          : "pi pi-pencil"
                      }`}
                      size="small"
                      className="bg-primary-primaryYellow border-0 text-black text-sm p-2 flex-1"
                      onClick={() => handleEditClick(rowData)}
                    />
                    <PrimereactBtn
                      // icon="pi pi-lock-open"
                      label="Reset Password"
                      hidden={
                        accessPermissions.partners === 1 ||
                        accessPermissions.partners === "1"
                      }
                      size="small"
                      disabled
                      className="bg-white border border-primary-primaryYellow text-black hover:bg-gray-100 text-sm p-2 flex-shrink-0"
                      // tooltip="Reset Password"
                      // tooltipOptions={{ position: "top" }}
                    />
                  </>
                ) : (
                  <PrimereactBtn
                    label={`${
                      accessPermissions.partners === 1 ||
                      accessPermissions.partners === "1"
                        ? ""
                        : "Create Super Admin Account"
                    }`}
                    icon={`${
                      accessPermissions.partners === 1 ||
                      accessPermissions.partners === "1"
                        ? "pi pi-eye"
                        : ""
                    }`}
                    size="small"
                    className="bg-primary-primaryYellow text-sm border-0 text-secondary-purpleGray p-2 w-full"
                    onClick={() => {
                      if (
                        accessPermissions.partners === 1 ||
                        accessPermissions.partners === "1"
                      ) {
                        handleEditClick(rowData);
                      } else {
                        handleAddPartnerAccount(rowData, "existing");
                      }
                    }}
                  />
                )}
              </div>
            );
          }}
        />
      </DataTable>
    </Card>
  );
};

export default NewPartnerTable;
